import randomColor from "random-color";
import { distanceType } from "../models/types";

const getRandomColors = () =>
  [...Array(100).keys()].map(() => randomColor().hexString());

export const INPUT_MAX_LENGTH = 30;
export const OPTIONS = [
  { key: 0, title: "Use coordinates", value: distanceType.BY_COORDINATES },
  { key: 1, title: "Use link length", value: distanceType.BY_LINK_LENGTH },
  { key: 2, title: "Use weight", value: distanceType.BY_WEIGHT },
];

export enum DIFFICULTIES {
  EASY = 1,
  MEDIUM = 2,
  INTERMEDIATE = 3,
  HARD = 4,
}

export const NODE_COLOR = "#212121";
export const LINK_COLOR = "#331400";
export const ACTIVE_COLOR = "#1054D2";
export const FADE_COLOR = "#eeeeee";
export const DANGER_COLOR = "#dc3545";
export const START_COLOR = "#009900";
export const END_COLOR = "#ff3300";
export const CURRENT_COLOR = "#ff9900";
export const ROSE_COLOR = "#ff4d88";
export const COLORS = getRandomColors();

export const MAX_LEVEL = 5;
